import Vue from 'vue'
import VueRouter from 'vue-router'
//import goTo from 'vuetify/es5/services/goto'
import Missing from '@/views/404.vue'
//import Demo from '@/views/Demo.vue'


Vue.use(VueRouter)

const routes = [

    {
        path: '/',
        name: 'LandingPage',
        meta: {
            title: 'netMedia SR e.U.'
        },
        component: () =>
            import ('@/views/LandingPage.vue')
    },
    /*
    {
        path: '/about',
        name: 'About',
        meta: {
            title: 'About'
        },
        component: () =>
            import ('@/views/About.vue')
    },
    */

    /*
    {
        path: '/parallax-home',
        name: 'ParallaxHome',
        meta: {
            title: 'Parallax Home || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/all-home-version/ParallaxHome.vue')
    },
    */
   /*
    {
        path: '/service',
        name: 'Service',
        meta: {
            title: 'Service || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/service/Service.vue')
    },
    */
    {
        path: '/app-development',
        name: 'AppDevelopment',
        meta: {
            title: 'App Development'
        },
        component: () =>
            import ('@/views/service/AppDevelopment.vue')
    },
    {
        path: '/smart-home',
        name: 'SmartHome',
        meta: {
            title: 'Smart Home'
        },
        component: () =>
            import ('@/views/service/SmartHome.vue')
    },
    {
        path: '/network',
        name: 'Network',
        meta: {
            title: 'Network'
        },
        component: () =>
            import ('@/views/service/Network.vue')
    },
    {
        path: '/prototyping',
        name: 'Prototyping',
        meta: {
            title: 'Prototyping'
        },
        component: () =>
            import ('@/views/service/Prototyping.vue')
    },
    /*
    {
        path: '/blog',
        name: 'Blog',
        meta: {
            title: 'Blog || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/blog/Blog.vue')
    },
    {
        path: '/blog-details',
        name: 'BlogDetails',
        meta: {
            title: 'Blog Details || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/blog/BlogDetails.vue')
    },
    
    {
        path: '/portfolio',
        name: 'Portfolio',
        meta: {
            title: 'Portfolio || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/portfolio/Portfolio.vue')
    },
    {
        path: '/portfolio-details',
        name: 'PortfolioDetails',
        meta: {
            title: 'Portfolio Details || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/portfolio/PortfolioDetails.vue')
    },
    {
        path: '/team',
        name: 'Team',
        meta: {
            title: 'Team || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/Team.vue')
    },
    {
        path: '/button',
        name: 'Button',
        meta: {
            title: 'Button || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/Button.vue')
    },
    {
        path: '/pricing-plan',
        name: 'PricingPlan',
        meta: {
            title: 'Pricing Plan || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/PricingPlan.vue')
    },
    {
        path: '/accordion-with-tab',
        name: 'AccordionWithTab',
        meta: {
            title: 'Accordion With Tab || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/AccordionWithTab.vue')
    },
    {
        path: '/testimonial',
        name: 'Testimonial',
        meta: {
            title: 'Tesimonial || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/Testimonial.vue')
    },
    {
        path: '/column',
        name: 'Column',
        meta: {
            title: 'Column || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/Column.vue')
    },
    {
        path: '/list-style',
        name: 'ListStyle',
        meta: {
            title: 'List Style || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/ListStyle.vue')
    },
    
    {
        path: '/contact-form',
        name: 'ContactForm',
        meta: {
            title: 'Contact Form || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/ContactForm.vue')
    },
    
    {
        path: '/video-popup',
        name: 'VideoPopup',
        meta: {
            title: 'Video Popup || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/VideoPopup.vue')
    },
    */
    /*
    {
        path: '/brand',
        name: 'Brand',
        meta: {
            title: 'Brand || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/Brand.vue')
    },
    */
    /*
    {
        path: '/counter',
        name: 'Counter',
        meta: {
            title: 'Counter || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/Counter.vue')
    },
    */
    {
        path: '/contact',
        name: 'Contact',
        meta: {
            title: 'Contact || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/Contact.vue')
    },
    /*
    {
        path: '/gallery',
        name: 'Gallery',
        meta: {
            title: 'Gallery || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/Gallery.vue')
    },
    {
        path: '/progressbar',
        name: 'Progressbar',
        meta: {
            title: 'Progressbar || VueJS Multipurpose Template'
        },
        component: () =>
            import ('@/views/Progressbar.vue')
    },
    */
    {
        path: '*',
        component: Missing,
        meta: {
            title: '404 || VueJS Multipurpose Template'
        },
    }
]


const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
          if (from.path === to.path) {
            // Gleiche Seite, also verzögert scrollen
            return new Promise(resolve => {
              requestAnimationFrame(() => {
                resolve({ selector: to.hash });
              });
            });
          } else {
            // Direktes Scrollen auf einer neuen Seite
            return { selector: to.hash };
          }
        } else if (savedPosition) {
          return savedPosition;
        } else {
          return { x: 0, y: 0 };
        }
      }
      
  });

router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    next()
})


export default router